<template>
    <div class="modal_cont smn_modal">
        <!-- 타이틀 -->
        <div class="smn_title_row">
            <h2 class="smn_title">가맹/창업상담 신청</h2>
            <button type="button" class="smn_close" aria-label="닫기" @click="closeModal"></button>
        </div>

        <div class="modal_content smn_body">
            <!-- 인트로 -->
            <div class="smn_intro">
                <strong>안녕하세요!<br>GS THE FRESH 1:1 상담<br class="m_br">컨설턴트 {{ consultantName }} 입니다.</strong>
                <p>아래의 상담 신청서를 작성하시면 귀하만의 창업 상담을 받아 보실 수있습니다. <br />
                    담당자와 통화가 원활하지 않는 경우 상담신청 부탁 드립니다. 담당자가 확인 후 연락 드리겠습니다.</p>
            </div>

            <!-- 컨설턴트와 1:1 상담 -->
            <div class="gray_box consult_box">
                <div class="consent_body">
                    <div class="flex_wrap">
                        <div class="consent_img_wrap">
                            <img v-if="consultantImageUrl" :src="consultantImageUrl" :alt="consultantName + ' 컨설턴트'" />
                        </div>
                        <div class="consent_info">
                            <h3 class="consent_info_title">컨설턴트와 1:1 상담</h3>
                            <p>가맹/창업 컨설턴트가 1:1로 상담해 드립니다.<br />
                                가맹/창업 컨설턴트에게 문의하시면 자세한 상담을 받으실 수 있습니다.</p>
                            <button type="button">{{ consultantName }} 컨설턴트</button>
                        </div>
                    </div>
                    <div class="consent_notice">
                        <ul class="list_caution">
                            <li>
                                <p>※ 입력하신 정보는 입지상담을 위해서만 사용합니다. 수집항목, 이용 및 목적, 보유 및 이용기간은 다음과 같으며, 기타 개인정보 취급사항은 홈페이지 하단의 "개인정보 처리방침"을 참고하시기 바랍니다.</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 개인정보 동의 -->
            <div class="gray_box consent_box">
                <div class="consent_info">
                    <h3 class="consent_info_title">개인정보 수집·이용 동의</h3>
                    <ul class="consent_info_list">
                        <li>입력하신 정보는 입지상담을 위해서만 사용합니다. 수집항목, 이용 및 목적, 보유 및 이용기간은 다음과 같으며,기타 개인정보 취급사항은 홈페이지 하단의 "개인정보 처리방침"을 참고하시기 바랍니다.</li>
                        <li>수집하는 개인정보 항목: 이름, 이메일, 휴대폰번호</li>
                        <li>수집이용 및 목적: 수집한 개인정보를 본인 식별 및 문의사항 확인 및 답변을 위해 활용</li>
                        <li>보유 및 이용기간: 접수 후 1년</li>
                    </ul>
                    <div class="consent_notice">
                        <p class="consent_notice_text">고객님께서는 본 동의에 거부하실 권리가 있으나, 동의하지 않으실 경우<br class="p_br">사업설명회 신청 글 작성이 불가능합니다.</p>
                        <label class="consent_radio_label">
                            <input type="radio" class="consent_radio" name="consent_agree" value="agree" v-model="consentAgree" @click="consentAgree = consentAgree === 'agree' ? '' : 'agree'" />
                            <span class="consent_radio_text">동의합니다.</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="middle_bts_wrap">
                <button :class="{ active: hasStore === true }" @click="hasStore = true">내가 소유한 점포가 있다.</button>
                <button :class="{ active: hasStore === false }" @click="hasStore = false">내가 소유한 점포가 없다.</button>
            </div>

            <!-- 고객정보 폼 -->
            <div class="apply_form">
                <div class="form_head">
                    <h3 class="form_head_title">고객정보</h3>
                    <span class="form_required_note">* 필수 입력사항</span>
                </div>
                <div class="form_body">
                    <!-- 이름 -->
                    <div class="form_row">
                        <div class="form_label">이름<span class="form_required">*</span></div>
                        <div class="form_field">
                            <Inputs type="text" v-model="consultForm.name" maxlength="100" />
                        </div>
                    </div>
                    <!-- 이메일 -->
                    <div class="form_row">
                        <div class="form_label">이메일</div>
                        <div class="form_field form_field_email">
                            <Inputs type="text" v-model="consultForm.emailId" />
                            <span class="form_sep">@</span>
                            <Inputs v-if="consultForm.emailDomain === ''" type="text" v-model="consultForm.emailDomainCustom" placeholder="직접입력" />
                            <Inputs v-else type="text" :model-value="consultForm.emailDomain" :is-readonly="true" />
                            <SelectBox :options="emailDomainOptions" v-model="consultForm.emailDomain" initMsg="" />
                        </div>
                    </div>
                    <!-- 연락처 -->
                    <div class="form_row">
                        <div class="form_label">연락처<span class="form_required">*</span></div>
                        <div class="form_field form_field_phone">
                            <SelectBox :options="phoneOptions" v-model="consultForm.phone1" />
                            <span class="form_sep">-</span>
                            <Inputs
                                type="text"
                                :model-value="consultForm.phone2"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                :maxlength="PHONE_PART_MAX_LENGTH"
                                @beforeinput="preventNonDigitInput"
                                @input="handleNumericInput($event, 'phone2', PHONE_PART_MAX_LENGTH)"
                                @update:modelValue="consultForm.phone2 = sanitizeDigits($event, PHONE_PART_MAX_LENGTH)"
                            />
                            <span class="form_sep">-</span>
                            <Inputs
                                type="text"
                                :model-value="consultForm.phone3"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                :maxlength="PHONE_PART_MAX_LENGTH"
                                @beforeinput="preventNonDigitInput"
                                @input="handleNumericInput($event, 'phone3', PHONE_PART_MAX_LENGTH)"
                                @update:modelValue="consultForm.phone3 = sanitizeDigits($event, PHONE_PART_MAX_LENGTH)"
                            />
                        </div>
                    </div>

                    <!-- 주소 -->
                    <div class="form_row">
                        <div class="form_label">{{ hasStore === false ? "자택주소" : "소유점포 주소" }}<span class="form_required">*</span></div>
                        <div class="form_field form_field_region">
                            <SelectBox :options="sidoOptions" v-model="consultForm.regionSido" initMsg="시/도 선택" @change="selectSidoComboChange" />
                            <SelectBox :options="sigunguOptions" v-model="consultForm.regionSigungu" initMsg="구/군 선택" :is-disabled="!consultForm.regionSido" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 상담내용 폼 (점포 소유 시에만 표시) -->
            <div class="apply_form" v-show="hasStore === true">
                <div class="form_head">
                    <h3 class="form_head_title">상담내용</h3>
                    <span class="form_required_note">* 필수 입력사항</span>
                </div>
                <div class="form_body">
                    <!-- 소유점포 면적 -->
                    <div class="form_row form_row_area">
                        <div class="form_label">소유점포 면적</div>
                        <div class="form_field form_field_area">
                            <div class="form_sub_group">
                                <span class="form_sub_label">계약면적</span>
                                <div class="form_sub_input_wrap">
                                    <Inputs
                                        type="text"
                                        :model-value="consultForm.areaContract"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        :maxlength="EXTENT_MAX_LENGTH"
                                        @beforeinput="preventNonDigitInput"
                                        @input="handleNumericInput($event, 'areaContract', EXTENT_MAX_LENGTH)"
                                        @update:modelValue="consultForm.areaContract = sanitizeDigits($event, EXTENT_MAX_LENGTH)"
                                    />
                                    <span class="form_sub_unit">m²</span>
                                </div>
                            </div>
                            <div class="form_sub_group">
                                <span class="form_sub_label">전용면적</span>
                                <div class="form_sub_input_wrap">
                                    <Inputs
                                        type="text"
                                        :model-value="consultForm.areaExclusive"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        :maxlength="EXTENT_MAX_LENGTH"
                                        @beforeinput="preventNonDigitInput"
                                        @input="handleNumericInput($event, 'areaExclusive', EXTENT_MAX_LENGTH)"
                                        @update:modelValue="consultForm.areaExclusive = sanitizeDigits($event, EXTENT_MAX_LENGTH)"
                                    />
                                    <span class="form_sub_unit">m²</span>
                                </div>
                            </div>
                            <span class="area_note">* m² = (기준)평 x 3.3</span>
                        </div>
                    </div>
                    <!-- 현재수퍼운영여부 -->
                    <div class="form_row">
                        <div class="form_label">현재수퍼운영여부<span class="form_required">*</span></div>
                        <div class="form_field check_list">
                            <Inputs type="radio" name="crnt_oper_yn" value="Y" v-model="consultForm.currentSuperOperYn" text="Y" />
                            <Inputs type="radio" name="crnt_oper_yn" value="N" v-model="consultForm.currentSuperOperYn" text="N" />
                        </div>
                    </div>
                    <!-- 수퍼 운영자 일 경우 -->
                    <div class="form_row check_row">
                        <div class="form_label">수퍼 운영자 일 경우</div>
                        <div class="form_field form_field_check">
                            <div class="form_sub_group">
                                <span class="form_sub_label">취급 품목 체크</span>
                                <div class="check_list">
                                    <Inputs v-for="opt in superItemOptions" :key="opt.value"
                                            type="checkbox" :value="opt.value" v-model="consultForm.superItems" :text="opt.label" />
                                </div>
                            </div>
                            <div class="check_etc">
                                <span class="form_sub_label">기타</span>
                                <Inputs type="text" v-model="consultForm.superItemEtc" />
                            </div>
                            <div class="check_etc">
                                <span class="form_sub_label">테넌트 및 수수료코너 현황</span>
                                <Inputs type="text" v-model="consultForm.tenantFeeStatus" maxlength="500" />
                            </div>
                        </div>
                    </div>
                    <!-- 계약조건 -->
                    <div class="form_row contract_row">
                        <div class="form_label">계약조건</div>
                        <div class="form_field form_field_contract">
                            <div class="form_sub_group">
                                <span class="form_sub_label">계약 기간</span>
                                <div class="form_sub_inputs">
                                    <Inputs type="date" v-model="consultForm.contractStart" />
                                    <span class="form_sep">~</span>
                                    <Inputs type="date" v-model="consultForm.contractEnd" />
                                </div>
                            </div>
                            <div class="form_sub_group">
                                <span class="form_sub_label">보증금/월임대료</span>
                                <div class="contract_rent">
                                    <div class="form_sub_input_wrap">
                                        <Inputs
                                            type="text"
                                            :model-value="consultForm.deposit"
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                            :maxlength="AMOUNT_MAX_LENGTH"
                                            @beforeinput="preventNonDigitInput"
                                            @input="handleNumericInput($event, 'deposit', AMOUNT_MAX_LENGTH)"
                                            @update:modelValue="consultForm.deposit = sanitizeDigits($event, AMOUNT_MAX_LENGTH)"
                                        />
                                        <span class="form_sub_unit">만 원</span>
                                    </div>
                                    <div class="form_sub_input_wrap">
                                        <Inputs
                                            type="text"
                                            :model-value="consultForm.monthlyRent"
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                            :maxlength="AMOUNT_MAX_LENGTH"
                                            @beforeinput="preventNonDigitInput"
                                            @input="handleNumericInput($event, 'monthlyRent', AMOUNT_MAX_LENGTH)"
                                            @update:modelValue="consultForm.monthlyRent = sanitizeDigits($event, AMOUNT_MAX_LENGTH)"
                                        />
                                        <span class="form_sub_unit">만 원</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 상담내용 폼 (점포 미소유 시에만 표시) -->
            <div class="apply_form" v-show="hasStore === false">
                <div class="form_head">
                    <h3 class="form_head_title">상담내용</h3>
                    <span class="form_required_note">* 필수 입력사항</span>
                </div>
                <div class="form_body">
                    <div class="form_row">
                        <div class="form_label">투자가능금액<span class="form_required">*</span></div>
                        <div class="form_field">
                            <SelectBox :options="investmentAmountOptions" v-model="consultForm.ivstPsblAmtDvCd" initMsg="선택" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">기대소득<span class="form_required">*</span></div>
                        <div class="form_field">
                            <SelectBox :options="incomeAmountOptions" v-model="consultForm.incomAmtDvCd" initMsg="선택" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">개설희망지역<span class="form_required">*</span></div>
                        <div class="form_field form_field_region">
                            <SelectBox :options="sidoOptions" v-model="consultForm.hopeRegionSido" initMsg="시/도 선택" @change="selectHopeSidoComboChange" />
                            <SelectBox :options="hopeSigunguOptions" v-model="consultForm.hopeRegionSigungu" initMsg="구/군 선택" :is-disabled="!consultForm.hopeRegionSido" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">수퍼근무경험<span class="form_required">*</span></div>
                        <div class="form_field check_list">
                            <Inputs v-for="opt in superWorkCareerOptions" :key="opt.value"
                                    type="radio" name="sm_work_carer_cd" :value="opt.value" v-model="consultForm.smWorkCarerCd" :text="opt.label" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">개설희망시기<span class="form_required">*</span></div>
                        <div class="form_field form_field_region">
                            <SelectBox :options="hopeYearOptions" v-model="consultForm.opstHopeYy" initMsg="년 선택" />
                            <SelectBox :options="hopeMonthOptions" v-model="consultForm.opstHopeMm" initMsg="월 선택" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">개설희망 가맹타입<span class="form_required">*</span></div>
                        <div class="form_field check_list">
                            <Inputs v-for="opt in franchiseTypeOptions" :key="opt.value"
                                    type="radio" name="gsf_fran_type_cd" :value="opt.value" v-model="consultForm.gsfFranTypeCd" :text="opt.label" />
                        </div>
                    </div>
                    <div class="form_row">
                        <div class="form_label">문의내용</div>
                        <div class="form_field form_field_textarea">
                            <textarea v-model="consultForm.inqryCntnt" maxlength="1000"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 버튼 -->
        </div>
        
        <div class="smn_bottom">
            <Buttons btn-class="btn_big primary" :disabled="submitting" @click="submitConsultationRequest">상담신청</Buttons>
            <Buttons btn-class="btn_big gary" @click="closeModal">다시작성</Buttons>
        </div>

    </div>
</template>

<script setup>
import { ref, reactive, computed, defineProps, onMounted } from "vue";
import modal from "@/utils/popupModal";
import Inputs from "@/components/Inputs.vue";
import SelectBox from "@/components/SelectBox.vue";
import Buttons from "@/components/Buttons.vue";
import { startupAPI } from "@/api/startupAPI.js";
import { gisAPI } from "@/api/gisAPI.js";
import { COMM_CD_GROUP_IDS, loadCommCdGroupItems } from "@/utils/CommonCode.js";

const props = defineProps({
    consultant: {
        type: Object,
        default: () => ({})
    }
});

const consultantName = computed(() => props.consultant.name || props.consultant.psnNm || "-");
const consultantPsnId = computed(() => props.consultant.psnId || "");
const consultantImageUrl = computed(() =>
    props.consultant.img ||
    props.consultant.psnFileUrl ||
    props.consultant.psnFilePathNm ||
    props.consultant.fileUrl ||
    props.consultant.filePathNm ||
    ""
);

const consentAgree = ref("");
const hasStore = ref(null); // null: 미선택 / true: 있다 / false: 없다
const PHONE_PART_MAX_LENGTH = 4;
const EXTENT_MAX_LENGTH = 10;
const AMOUNT_MAX_LENGTH = 12;

const sidoOptions = ref([]);
const sigunguOptions = ref([]);
const hopeSigunguOptions = ref([]);
const superItemOptions = ref([]);
const investmentAmountOptions = ref([]);
const incomeAmountOptions = ref([]);
const superWorkCareerOptions = ref([]);
const franchiseTypeOptions = ref([]);
const submitting = ref(false);

const consultForm = reactive({
    name: "",
    phone1: "010",
    phone2: "",
    phone3: "",
    emailId: "",
    emailDomain: "",
    emailDomainCustom: "",
    regionSido: "",
    regionSigungu: "",
    prevJob: "",
    areaContract: "",
    areaExclusive: "",
    currentSuperOperYn: "",
    superItems: [],
    superItemEtc: "",
    tenantFeeStatus: "",
    contractStart: "",
    contractEnd: "",
    deposit: "",
    monthlyRent: "",
    ivstPsblAmtDvCd: "",
    incomAmtDvCd: "",
    hopeRegionSido: "",
    hopeRegionSigungu: "",
    smWorkCarerCd: "",
    opstHopeYy: "",
    opstHopeMm: "",
    gsfFranTypeCd: "",
    inqryCntnt: "",
});

const phoneOptions = [
    { value: "010", label: "010" },
    { value: "011", label: "011" },
    { value: "016", label: "016" },
    { value: "017", label: "017" },
    { value: "018", label: "018" },
    { value: "019", label: "019" },
];
const emailDomainOptions = [
    { value: "", label: "직접입력" },
    { value: "naver.com", label: "naver.com" },
    { value: "hanmail.net", label: "hanmail.net" },
    { value: "hotmail.com", label: "hotmail.com" },
    { value: "nate.com", label: "nate.com" },
    { value: "yahoo.co.kr", label: "yahoo.co.kr" },
    { value: "empas.com", label: "empas.com" },
    { value: "dreamwiz.com", label: "dreamwiz.com" },
    { value: "freechal.com", label: "freechal.com" },
    { value: "lycos.co.kr", label: "lycos.co.kr" },
    { value: "korea.com", label: "korea.com" },
    { value: "gmail.com", label: "gmail.com" },
    { value: "hanmir.com", label: "hanmir.com" },
    { value: "paran.com", label: "paran.com" },
];
const currentYear = new Date().getFullYear();
const hopeYearOptions = Array.from({ length: 6 }, (_, index) => {
    const year = String(currentYear + index);
    return { value: year, label: `${year}년` };
});
const hopeMonthOptions = Array.from({ length: 12 }, (_, index) => {
    const month = String(index + 1).padStart(2, "0");
    return { value: month, label: `${month}월` };
});

onMounted(() => {
    loadOptions();
});

async function loadOptions() {
    const codeItems = await loadCommCdGroupItems({
        sidoItems: COMM_CD_GROUP_IDS.GS25_BRFS_REGN_DV_CD,
        hndlAtcItems: COMM_CD_GROUP_IDS.HNDL_ATC_CD,
        investmentAmountItems: COMM_CD_GROUP_IDS.IVST_PSBL_AMT_DV_CD,
        incomeAmountItems: COMM_CD_GROUP_IDS.INCOM_AMT_DV_CD,
        superWorkCareerItems: COMM_CD_GROUP_IDS.SM_WORK_CARER_CD,
        franchiseTypeItems: COMM_CD_GROUP_IDS.GSF_FRAN_TYPE_CD,
    });

    sidoOptions.value = codeItems.sidoItems.map(toSelectOption);
    superItemOptions.value = codeItems.hndlAtcItems.map(toSelectOption);
    investmentAmountOptions.value = codeItems.investmentAmountItems.map(toSelectOption);
    incomeAmountOptions.value = codeItems.incomeAmountItems.map(toSelectOption);
    superWorkCareerOptions.value = codeItems.superWorkCareerItems.map(toSelectOption);
    franchiseTypeOptions.value = codeItems.franchiseTypeItems.map(toSelectOption);
}

function toSelectOption(item) {
    return {
        value: item.value,
        label: item.title,
    };
}

async function selectSidoComboChange() {
    consultForm.regionSigungu = "";
    sigunguOptions.value = [];

    if (!consultForm.regionSido) return;

    sigunguOptions.value = await fetchSigunguOptions(consultForm.regionSido);
}

async function selectHopeSidoComboChange() {
    consultForm.hopeRegionSigungu = "";
    hopeSigunguOptions.value = [];

    if (!consultForm.hopeRegionSido) return;

    hopeSigunguOptions.value = await fetchSigunguOptions(consultForm.hopeRegionSido);
}

async function fetchSigunguOptions(sido) {
    try {
        const response = await gisAPI.searchGungu({ sido });
        if (response.data.resultCode === "00000") {
            return (response.data.result || []).map((gungu) => ({
                value: gungu.gunguCd,
                label: gungu.gunguNm,
            }));
        }
    } catch (error) {
        // console.error("시군구 목록 조회 오류:", error);
        return [];
    }

    return [];
}

function closeModal(eventOrElement) {
    const targetElement = eventOrElement?.currentTarget || eventOrElement?.target || eventOrElement;

    if (targetElement) {
        modal.close(targetElement);
    }
}

function validateConsultForm() {
    if (consentAgree.value !== "agree") return "개인정보 수집 및 이용에 동의해 주세요.";
    if (hasStore.value === null) return "점포 소유 여부를 선택해 주세요.";
    if (!consultForm.name.trim()) return "이름을 입력해 주세요.";
    if (!consultForm.phone2.trim() || !consultForm.phone3.trim()) return "연락처를 입력해 주세요.";
    if (!consultForm.regionSido || !consultForm.regionSigungu) return `${hasStore.value ? "점포" : "자택"} 주소를 선택해 주세요.`;

    if (hasStore.value) {
        if (!consultForm.currentSuperOperYn) return "현재수퍼운영여부를 선택해 주세요.";
    } else {
        if (!consultForm.ivstPsblAmtDvCd) return "투자가능금액을 선택해 주세요.";
        if (!consultForm.incomAmtDvCd) return "기대소득을 선택해 주세요.";
        if (!consultForm.hopeRegionSido || !consultForm.hopeRegionSigungu) return "개설희망지역을 선택해 주세요.";
        if (!consultForm.smWorkCarerCd) return "수퍼근무경험을 선택해 주세요.";
        if (!consultForm.opstHopeYy || !consultForm.opstHopeMm) return "개설희망시기를 선택해 주세요.";
        if (!consultForm.gsfFranTypeCd) return "개설희망 가맹타입을 선택해 주세요.";
    }

    return "";
}

function sanitizeDigits(value, maxLength) {
    return String(value ?? "").replace(/\D/g, "").slice(0, maxLength);
}

function preventNonDigitInput(event) {
    if (event.inputType?.startsWith("delete") || !event.data) return;
    if (/\D/.test(event.data)) event.preventDefault();
}

function handleNumericInput(event, fieldName, maxLength) {
    const value = sanitizeDigits(event.target.value, maxLength);
    event.target.value = value;
    consultForm[fieldName] = value;
}

function toNumberOrNull(value) {
    if (value === null || value === undefined || value === "") return null;

    const numberValue = Number(String(value).replace(/,/g, ""));
    return Number.isNaN(numberValue) ? null : numberValue;
}

function toCompactDate(value) {
    return String(value ?? "").replace(/\D/g, "").slice(0, 8);
}

function getEmailAddress() {
    const emailId = consultForm.emailId.trim();
    const emailDomain = (consultForm.emailDomain || consultForm.emailDomainCustom).trim();

    if (!emailId || !emailDomain) return "";
    return `${emailId}@${emailDomain}`;
}

function createHndlAtcList() {
    const selectedItems = consultForm.superItems.map((hndlAtcCd) => ({ hndlAtcCd }));
    const etcCntnt = consultForm.superItemEtc.trim();

    if (!etcCntnt) return selectedItems;

    const etcItem = selectedItems.find((item) => {
        const option = superItemOptions.value.find((opt) => opt.value === item.hndlAtcCd);
        return option?.label?.includes("기타") || option?.value === "99" || /ETC/i.test(option?.value || "");
    });

    if (etcItem) {
        etcItem.hndlAtcEtcCntnt = etcCntnt;
        return selectedItems;
    }

    return [
        ...selectedItems,
        {
            hndlAtcCd: "",
            hndlAtcEtcCntnt: etcCntnt,
        },
    ];
}

function removeEmptyParams(params) {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== "" && value !== null && value !== undefined)
    );
}

function createSubmitPayload() {
    return removeEmptyParams({
        wrtrNm: consultForm.name.trim(),
        psnId: consultantPsnId.value,
        wrtrEmailAddr: getEmailAddress(),
        wrtrTelno: [consultForm.phone1, consultForm.phone2.trim(), consultForm.phone3.trim()].join("-"),
        regnCd: consultForm.regionSido,
        borCd: consultForm.regionSigungu,
        strOwnYn: hasStore.value ? "Y" : "N",
        strContExtent: hasStore.value ? toNumberOrNull(consultForm.areaContract) : null,
        strExcluExtent: hasStore.value ? toNumberOrNull(consultForm.areaExclusive) : null,
        crntOperYn: hasStore.value ? consultForm.currentSuperOperYn : "",
        feePrcnCntnt: hasStore.value ? consultForm.tenantFeeStatus.trim() : "",
        contBeginDt: hasStore.value ? toCompactDate(consultForm.contractStart) : "",
        contEndDt: hasStore.value ? toCompactDate(consultForm.contractEnd) : "",
        gramtAmt: hasStore.value ? toNumberOrNull(consultForm.deposit) : null,
        mmRentAmt: hasStore.value ? toNumberOrNull(consultForm.monthlyRent) : null,
        opstHopeRegnCd: hasStore.value ? "" : consultForm.hopeRegionSido,
        opstHopeBorCd: hasStore.value ? "" : consultForm.hopeRegionSigungu,
        opstHopeYy: hasStore.value ? "" : consultForm.opstHopeYy,
        opstHopeMm: hasStore.value ? "" : consultForm.opstHopeMm,
        inqryCntnt: hasStore.value ? "" : consultForm.inqryCntnt.trim(),
        smWorkCarerCd: hasStore.value ? "" : consultForm.smWorkCarerCd,
        gsfFranTypeCd: hasStore.value ? "" : consultForm.gsfFranTypeCd,
        ivstPsblAmtDvCd: hasStore.value ? "" : consultForm.ivstPsblAmtDvCd,
        incomAmtDvCd: hasStore.value ? "" : consultForm.incomAmtDvCd,
        answrYn: "N",
        gsfConslAceptStatCd: "01",
        hndlAtcList: hasStore.value ? createHndlAtcList() : [],
    });
}

async function submitConsultationRequest(event) {
    const targetElement = event?.currentTarget;
    const validationMessage = validateConsultForm();

    if (validationMessage) {
        alert(validationMessage);
        return;
    }

    if (submitting.value) return;
    submitting.value = true;

    try {
        const response = await startupAPI.insertGtfStartupConsultationRequest(createSubmitPayload());
        const resultCode = response?.data?.resultCode;

        if (resultCode && resultCode !== "00000") {
            alert(response?.data?.resultMessage || "창업상담 신청에 실패했습니다.");
            return;
        }

        alert("창업상담 신청이 완료되었습니다.");
        closeModal(targetElement);
    } catch (error) {
        alert("창업상담 신청 중 오류가 발생했습니다.");
    } finally {
        submitting.value = false;
    }
}
</script>

<style scoped>
:deep(.m_br) { display: none; }
:deep(.p_br) { display: block; }
.smn_modal { --color-brand-primary: #15b874; }
.smn_bottom :deep(.primary) { background-color: var(--color-brand-primary); }
.smn_modal :deep([class*="btn_"][class*="primary"]) { color: #fff; }
.smn_title_row { display: flex; align-items: flex-start; justify-content: space-between; min-height: 92px; margin: 0; padding: 0; }
.smn_title { color: #161616; font-size: 4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.3; }
.smn_close { width: 40px; height: 40px; background: none; border: none; border-radius: 50%; cursor: pointer; flex-shrink: 0; position: relative; }
.smn_close::before, .smn_close::after { width: 22px; border-top: 2px solid #161616; content: ""; position: absolute; top: 50%; left: 50%; }
.smn_close::before { transform: translate(-50%, -50%) rotate(45deg); }
.smn_close::after { transform: translate(-50%, -50%) rotate(-45deg); }
.smn_intro strong { color: #161616; font-size: 3.2rem; line-height: 1.3; letter-spacing: -0.01em; }
.smn_intro > p { margin-top: 16px; color: #161616; font-size: 2rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.35; }
.consent_body { padding: 32px; }
.flex_wrap { display: flex; align-items: flex-start; gap: 20px; }
.consent_img_wrap { width: 114px; height: 152px; border: 1px solid #000; flex-shrink: 0; overflow: hidden; }
.consent_img_wrap > img { width: 100%; height: 100%; object-fit: cover; display: block; }
.consult_box .consent_info { padding: 0; display: flex; flex-direction: column; gap: 24px; }
.consult_box .consent_info_title { font-size: 2.4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.35; color: #161616; }
.consult_box .consent_info > p { font-size: 1.6rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.5; color: #161616; }
.consult_box .consent_info > button { width: fit-content; padding: 4px 12px; background: #e8f8f1; border: 1px solid #15b874; border-radius: 100px; color: #15b874; font-size: 1.4rem; font-weight: 500; letter-spacing: -0.01em; line-height: 1.4; cursor: default; }
.consult_box .consent_notice { border-top: 1px solid #e5e5e9; }
.list_caution { list-style: none; margin: 0; padding: 0; }
.list_caution > li > p { color: #67676f; font-size: 1.6rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.5; }
.gray_box { margin-top: 40px; border-radius: 12px; background-color: #f8f8f8; overflow: hidden; }
.consent_info { padding: 32px; }
.consent_info_title { font-size: 2.4rem; font-weight: 700; letter-spacing: -0.01em; line-height: 1.35; color: #161616; }
.consent_info_list { margin-top: 24px; display: flex; flex-direction: column; gap: 8px; }
.consent_info_list > li { padding-left: 10px; color: #67676f; font-size: 1.6rem; font-weight: 400; letter-spacing: -0.01em; line-height: 1.5; position: relative; }
.consent_info_list > li::before { content: ""; width: 4px; height: 1px; background-color: #67676f; position: absolute; left: 0; top: 0.5lh; }
.consent_notice { margin-top: 24px; padding-top: 24px; border-top: 1px solid #d7d7df; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.consent_notice_text { font-size: 1.6rem; font-weight: 700; line-height: 1.24; color: #161616; }
.consent_radio_label { display: flex; align-items: center; gap: 8px; flex-shrink: 0; cursor: pointer; white-space: nowrap; }
/*.consent_radio { width: 24px; height: 24px; padding: 0; appearance: none; border: 0; border-radius: 8px; background-color: #fff; cursor: pointer; flex-shrink: 0; position: relative; transition: border-color 0.2s, background-color 0.2s; }
.consent_radio:checked { border-color: #107af2; background-color: #107af2; }
.consent_radio:checked::after { width: 13px; height: 8px; background-color: #fff; content: ""; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
.consent_radio_text { font-size: 1.8rem; font-weight: 400; line-height: 1.4; color: #161616; }*/
.consent_radio, .consent_radio + .consent_radio_text:before {width:24px; height:24px;padding: 0;border: 0; background:url('@/assets/images/common/bg_input_check.png') -10px -10px no-repeat; box-sizing:border-box; top:0; left:0;}
.consent_radio:checked, .consent_radio:checked + .consent_radio_text:before {background-position:-141px -10px;}
.consent_radio:disabled, .consent_radio:disabled + .consent_radio_text:before {background-position:-272px -10px; cursor:default;}
.consent_radio:disabled, .consent_radio:checked:disabled + .consent_radio_text:before {background-position:-403px -10px; cursor:default;}
.consent_radio_text { font-size: 1.8rem; font-weight: 400; line-height: 1.4; color: #161616; }
.middle_bts_wrap { margin-top: 40px; display: flex; gap: 8px; }
.middle_bts_wrap > button { height: 52px; padding: 0 16px; background: #fff; border: 1px solid #90909a; border-radius: 10px; font-size: 1.8rem; font-weight: 700; cursor: pointer; transition: border-color 0.15s, color 0.15s; color: #161616; }
.middle_bts_wrap > button:hover, .middle_bts_wrap > button.active { border-color: #107af2; color: #107af2; }
.form_field > :deep(.input_wrap) { flex: 1; min-width: 0; max-width: 205px; }
.form_field_phone :deep(.select) { width: 134px; flex-shrink: 0; }
.form_field_phone :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_phone > :deep(.input_wrap) { max-width: 134px; flex: 1; min-width: 80px; }
.form_field_email > :deep(.input_wrap:nth-child(1)) { flex: 0 0 205px; width: 205px; min-width: 0; }
.form_field_email > :deep(.input_wrap:nth-child(3)) { flex: 0 0 180px; width: 180px; min-width: 0; }
.form_field_email :deep(.select) { flex: 0 0 180px; width: 180px; min-width: 0; }
.form_field_email :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_region :deep(.select) { flex: 1; min-width: 0; max-width: 220px; }
.form_field_region :deep(.select select) { width: 100%; font-size: 1.6rem; }
.form_field_textarea textarea { width: 100%; min-height: 120px; padding: 12px; border: 1px solid #d7d7df; border-radius: 4px; color: #161616; font-size: 1.6rem; line-height: 1.5; resize: vertical; box-sizing: border-box; }
.form_field_area .form_sub_input_wrap :deep(.input_wrap) { width: 160px; }
.check_list :deep(.input_wrap) { width: auto; }
.check_etc .form_sub_label { min-width: 28px; }
.check_etc :deep(.input_wrap) { flex: 1; max-width: 428px; }
.form_sub_inputs :deep(.input_wrap) { width: 155px; }
.contract_rent .form_sub_input_wrap :deep(.input_wrap) { width: 134px; }
.smn_bottom { margin-top: 40px; flex-shrink: 0; display: flex; align-items: center; justify-content: flex-end; gap: 8px; }
.smn_bottom > :deep(.btn_big) { width: 134px; text-align: center; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; }

@media (max-width: 768px) {
    :deep(.m_br) { display: block; }
    :deep(.p_br) { display: none; }
    .smn_modal { padding: 0 0 32px; }
    .modal_content { padding: 40px 0; }
    .smn_title_row { min-height: 60px; margin: 0 -20px; padding: 17px 20px; border-bottom: 1px solid #c4c4d0; }
    .smn_title { font-size: 1.8rem; line-height: 1.4; }
    .smn_close { width: 24px; height: 24px; }
    .smn_intro > p { margin-top: 12px; }
    .consent_info { padding: 30px 20px; }
    .consent_info_list > li { font-size: 1.4rem; line-height: 1.4; letter-spacing: -0.01em; }
    .consent_info_title { font-weight: 700; font-size: 1.8rem; line-height: 1.5; }
    .consent_notice { flex-direction: column; align-items: flex-start; gap: 16px; }
    .consent_notice_text { font-size: 1.4rem; line-height: 1.4; }
    .form_field_phone > :deep(.input_wrap) { max-width: none; flex: 1; }
    .form_field_email > :deep(.input_wrap:nth-child(1)) { flex: 1; min-width: 80px; }
    .form_field_email > :deep(.input_wrap:nth-child(3)) { flex: 1; min-width: 60px; }
    .form_field_email :deep(.select) { flex: 1 0 100%; width: 100%; }
    .form_field_region :deep(.select) { flex: 1 0 100%; width: 100%; max-width: 100%; }
    .consent_radio { width: 20px; height: 20px; }
    .consent_radio_text { font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; }
    .smn_bottom { margin-top: 0; justify-content: center; }
    .smn_bottom > :deep(.btn_big) { width: 100%; flex: 1; }
    .smn_bottom :deep(.primary) { background-color: var(--color-brand-primary); }
    .smn_intro strong { font-weight: 700; font-size: 2rem; line-height: 1.35; letter-spacing: -0.01em; }
    .smn_intro > p { margin-top: 12px; font-size: 1.8rem; line-height: 1.4; letter-spacing: 0; }
    .gray_box { margin-top: 32px; }
    .gray_box + .gray_box { margin-top: 60px; }
    .consent_body { padding: 30px 20px; }
    .consent_img_wrap { width: 90px; height: 120px; }
    .consult_box .consent_info_title { font-size: 1.8rem; line-height: 1.5; letter-spacing: 0; }
    .consult_box .consent_info { gap: 6px; }
    .consult_box .consent_info > p { font-size: 1.4rem; line-height: 1.4; letter-spacing: -0.01em; }
    .consult_box .consent_info > button { margin-top: 6px; }
    .consent_notice { margin-top: 24px; padding-top: 24px; }
    .consult_box .consent_notice { margin-top: 16px; padding-top: 16px; }
    .list_caution > li > p { font-size: 1.4rem; line-height: 1.4; letter-spacing: -0.01em; }
    .middle_bts_wrap { gap: 6px; }
    .middle_bts_wrap > button { padding: 0 5px; font-size: 1.6rem; line-height: 1.5; letter-spacing: -0.01em; }
    .form_field_area .form_sub_input_wrap { width: 100%; }
    .form_field_area .form_sub_input_wrap :deep(.input_wrap) { width: 100%; }
    .form_field > :deep(.input_wrap) { max-width: 100%; }
    .form_sub_inputs :deep(.input_wrap) { width: 100%; }
}
</style>
